// extracted by mini-css-extract-plugin
module.exports = {"removeBackground":"CouponItem_removeBackground__03Emm","neutralBackground":"CouponItem_neutralBackground__u3PJ2"};